export const FRAMEWORK = [
  { nom: "Django",  image: "/assets/img/icon/stack/django.webp" },
  { nom: "Odoo",    image: "/assets/img/icon/stack/odoo.svg" },
  { nom: "Kivy",    image: "/assets/img/icon/stack/kivy.webp" },
  { nom: "Symfony", image: "/assets/img/icon/stack/symfony.webp" },
];
